















import Vue from "vue";
import { Locale } from "@/constants/locale";

export default Vue.extend({
  name: "SecurityPopup",
  data() {
    return {
      Locale,
      TRANSLATION_KEY: "steps.SecurityPopup",
    };
  },
  methods: {
    handleClosePopup() {
      this.$store.state.showSecurityPopup = false
    }
  },
});
